import React, { createContext, useContext, useState } from 'react';
import { ABUtils } from '../../utils';

export const CarsSearchExtensionContextDefault = {
    setTabsStatus: () => {},
    tabsStatus: {
        flights: {
            isEnabled: false,
            isLoaded: false,
            showCheckbox: false,
        },
        dp: {
            isEnabled: false,
            isLoaded: false,
            showCheckbox: false,
        },
        hotels: {
            isEnabled: false,
            isLoaded: false,
            showCheckbox: false,
        },
        trains: {
            isEnabled: false,
            isLoaded: false,
            showCheckbox: false,
        },
    },
};

const CarsSearchExtensionContext = createContext(CarsSearchExtensionContextDefault);

export const CarsSearchExtensionProvider = ({ children }) => {
    const { carsSearchExtensionVariation } = ABUtils.getABs();
    const [tabsStatus, setTabsStatus] = useState({
        flights: {
            isEnabled: carsSearchExtensionVariation === 3,
            isLoaded: false,
            showCheckbox: carsSearchExtensionVariation === 2,
        },
        dp: {
            isEnabled: carsSearchExtensionVariation === 3,
            isLoaded: false,
            showCheckbox: carsSearchExtensionVariation === 2,
        },
        hotels: {
            isEnabled: carsSearchExtensionVariation === 3,
            isLoaded: false,
            showCheckbox: carsSearchExtensionVariation === 2,
        },
        trains: {
            isEnabled: false,
            isLoaded: false,
            showCheckbox: false,
        },
    });

    return (
        <CarsSearchExtensionContext.Provider value={{ tabsStatus, setTabsStatus }}>
            {children}
        </CarsSearchExtensionContext.Provider>
    );
};

export const useCarsSearchExtension = () => {
    return useContext(CarsSearchExtensionContext);
};
